import { Switch } from "../../../../core/form/fields";
import { isEmpty } from "../../../../core/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useSchoolConfig } from "../../../../core/hooks";
var CurriculumBoundarySwitch = function CurriculumBoundarySwitch(_ref) {
  var _channelOnboarding$da;
  var checked = _ref.checked,
    labelClass = _ref.labelClass,
    id = _ref.id,
    onCurriculumBoundarySwitchChanged = _ref.onCurriculumBoundarySwitchChanged;
  var _useSchoolConfig = useSchoolConfig(),
    channelOnboarding = _useSchoolConfig.channelOnboarding;
  var curriculumAttachment = channelOnboarding === null || channelOnboarding === void 0 || (_channelOnboarding$da = channelOnboarding.data) === null || _channelOnboarding$da === void 0 ? void 0 : _channelOnboarding$da.curriculum_attachment;
  var text = 'Uses knowledge from the uploaded curriculum document.';
  if (isEmpty(curriculumAttachment)) {
    text = 'Upload your curriculum document in the classroom onboarding for Nurture AI to learn your curriculum.';
  } else if (!curriculumAttachment.embeddings_completed) {
    text = 'Processing… Nurture AI is learning your curriculum. You can enable curriculum boundary in a few mins.';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3 mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-check form-switch ps-3"
  }, /*#__PURE__*/React.createElement(Switch, {
    disabled: isEmpty(curriculumAttachment) || !curriculumAttachment.embeddings_completed,
    id: id,
    labelClass: labelClass,
    label: 'Enable Curriculum Boundary',
    checked: checked,
    value: 5,
    onClick: onCurriculumBoundarySwitchChanged
  })), /*#__PURE__*/React.createElement("div", {
    className: "alert alert-light p-2 mt-2 border-none"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: faInfoCircle
  }), /*#__PURE__*/React.createElement("small", null, text)));
};
CurriculumBoundarySwitch.defaultProps = {
  id: 'curriculum-boundary',
  labelClass: ''
};
export default CurriculumBoundarySwitch;